import React from 'react';
import whatsIcon from '../../assets/whats.png';

import { Whats } from './styles';

interface IWhatsapp {
  number?: string;
  text?: string;
  message?: string;
  iconSize?: string;
  fontSize?: string;
  className?: string;
}

const Whatsapp: React.FC<IWhatsapp> = ({
  number = '555195181533',
  text = 'Oi, estou em seu website!',
  message = 'Tire suas dúvidas pelo WhatsApp',
  iconSize = '30px',
  fontSize = '16px',
  className = ''
}) => {
  return (
    <Whats
      iconSize={'20px'}
      fontSize={fontSize}
      href={`https://api.whatsapp.com/send?l=pt&phone=${number}&text=${encodeURI(
        text,
      )}`}
      className={`floater whatsapp ${className}`}
      style={{ color: '#18ae00' }}
    >
      <img
        className="icon whats"
        src={whatsIcon}
        title="Whatsapp"
        alt="Whatsapp"
      />
      {message}
    </Whats>
  );
};

export default Whatsapp;
